import React from 'react';

const RelatedSection = ({
  heading,
  slugPrefix,
  relatedData,
  isLimited,
  id = 'related-drugs'
}) => {
  const getRelatedList = () => {
    return relatedData
      .slice(0, isLimited ? 8 : relatedData.length)
      .map((item, id) => {
        return (
          <li key={id}>
            <a href={`${slugPrefix}/${item.slug}`}>
              {item.title ? item.title : item.name}
            </a>
          </li>
        );
      });
  };
  return (
    <section id={id} className="relatedDrugs mobile-section">
      <section className="top-drugs">
        <article>
          <h2 className="relatedDrugHeading">{heading}</h2>
          <ul>{getRelatedList()}</ul>
        </article>
      </section>
    </section>
  );
};

export default React.memo(RelatedSection);
